/**
 * Where a **Lieferung** stands (`CONTEXT.md`, *Lieferung*; TM-9636 / #1621).
 *
 * ```
 * QUEUED ──▶ SENT ──┬──▶ ACCEPTED
 *                                    ├──▶ REJECTED          (Dateiablehnung)
 *                                    ├──▶ NO_RESPONSE  (Ruf 1 blieb aus)
 *                                    └──▶ NOT_DELIVERED   (Fehler-DSN)
 * ```
 *
 * ⚠ **Only the Versand route has states.** Under Übergabe no Lieferung comes
 * into being: the practice gets the file pair in hand and nobody learns whether
 * it copied it. A state nothing ever advances would be a claim about a process
 * we do not see.
 *
 * ⚠ **`NO_RESPONSE` does not mean *lost*.** The Datenannahmestelle may have
 * processed it long ago; only `NOT_DELIVERED` says for certain that it does not
 * have the file. That is why nothing is ever resent automatically — that is
 * always a human's decision.
 *
 * ⚠ **No *diverted* and no *written off*.** Both belong to TM-9637 and may not
 * be pre-empted here: an `enum` column in MariaDB carries the index, and a value
 * no transition ever sets looks in the table like a state somebody can reach.
 */
export var LieferungStatus;
(function (LieferungStatus) {
    /** In its recipient's queue. Burns no counter yet. */
    LieferungStatus["QUEUED"] = "QUEUED";
    /** At the handover to the mail server. The Ruf 1 clock runs from here. */
    LieferungStatus["SENT"] = "SENT";
    /** Ruf 1 was an Annahmebestätigung. */
    LieferungStatus["ACCEPTED"] = "ACCEPTED";
    /** Ruf 1 was a **Dateiablehnung**. Under Versand that is Therame's incident. */
    LieferungStatus["REJECTED"] = "REJECTED";
    /** The Ruf 1 did not come. Says nothing about whether the file arrived. */
    LieferungStatus["NO_RESPONSE"] = "NO_RESPONSE";
    /** A failure DSN: the other side's mail server never accepted it. */
    LieferungStatus["NOT_DELIVERED"] = "NOT_DELIVERED";
})(LieferungStatus || (LieferungStatus = {}));
//# sourceMappingURL=lieferung-status.enum.js.map